mod.modules.define("Earnings", "BaseModule", function(fn) {
	"use strict";

	fn.prototype.init = function(params) {
		this.base("init", params);
	};

	fn.prototype.events = {
		".module-content button[data-action]:not(.active)" : {
			"click" : function(e, $el) {
				var action = $el.attr("data-action");

				this.reload({
					Period : action
				});
			}
		},
		".earnings-select-timeframe" : {
			"change" : function(e, $el) {
				var actualsTimeframe = this.el.find("select[data-type=actual]").val();
				var estimatesTimeframe = this.el.find("select[data-type=estimate]").val();

				this.reload({
					NumberOfActuals : actualsTimeframe,
					NumberOfEstimates : estimatesTimeframe
				});
			}
		},
		".earnings-select-overlay" : {
			"change" : function(e, $el) {
				var overlay = $el.val();

				this.reload({
					Overlay : overlay
				});
			}
		}
	};

});